<template>
  <el-dialog
    :visible.sync="modalOpen"
    :before-close="modalClose"
    :destroy-on-close="true"
    width="30%"
  >
    <div slot="title">
      <i class="el-icon-monitor"></i>
      {{ store.razon_social }}
    </div>
    <span>Registro de computadores</span>
    <el-row :gutter="20" style="margin-top: 10px;">
      <el-col :span="8">
        <el-input prefix-icon="el-icon-monitor" placeholder="Nombre" v-model="name" clearable></el-input>
      </el-col>
      <el-col :span="9">
        <el-input prefix-icon="el-icon-postcard" placeholder="Código" v-model="code" clearable></el-input>
      </el-col>
      <el-col :span="7">
        <el-button
          type="success"
          round
          icon="el-icon-check"
          :loading="loading"
          @click="saveComputer"
        >Registrar</el-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row
      :gutter="20"
      v-for="(computer, index) in computers"
      v-bind:key="index"
      style="margin-bottom: 10px;"
    >
      <el-col :span="8">
        <label for>
          <i class="el-icon-monitor"></i>
          {{ computer.name }}
        </label>
      </el-col>
      <el-col :span="9">
        <label for>
          <i class="el-icon-postcard"></i>
          {{ computer.code }}
        </label>
      </el-col>
      <el-col :span="7" style="text-align: center;">
        <el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            circle
            @click="deleteComputer(index, computer)"
          ></el-button>
        </el-tooltip>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="modalClose" icon="el-icon-close">Cancelar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveComputers } from "@/api/store";
export default {
  name: "ModalComputers",
  props: ["modalOpen", "store"],
  watch: {
    store: {
      deep: true,
      handler(val, oldVal) {
        if (Object.keys(val).length !== 0) {
          if (val.meta_data !== "") {
            var data = JSON.parse(val.meta_data);
            if (data !== null) {
              this.computers = data.computers;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      name: "",
      code: "",
      computers: [],
    };
  },
  methods: {
    modalClose() {
      this.$emit("close");
      this.name = "";
      this.code = "";
      this.computers = [];
    },
    saveComputer(remove) {
      var computer = this.computers;
      var txt = "Eliminación Exitosa"
      if (remove !== true) {
        this.loading = true;
        txt = "Registro Exitoso."
        computer.push({
          id: this.computers.length + 1,
          name: this.name,
          code: this.code,
        });
      }
      var datas = {
        id: this.store.id,
        computers: computer,
      };
      saveComputers(datas)
        .then(({ data }) => {
          this.name = "";
          this.code = "";
          this.$emit("refresh");
          this.$message({
            message: "Registro Exitoso.",
            type: "success",
          });
          this.loading = false;
        })
        .catch(function (error) {
          this.loading = false;
          this.$message.error("Error! " + error);
          console.log(error);
        });
    },
    deleteComputer(index, computer) {
      this.computers.splice(index, 1);
      this.saveComputer(true)
    },
  },
};
</script>